import * as Yup from "yup";

export const EmailValidation = Yup.object().shape({
  email: Yup.string().required("Email Required").email("Invalid email address"),
});

export const OtpValidation = Yup.object().shape({
  otp: Yup.string()
    .trim()
    .matches(/^[0-9]{6}$/, "Please eneter only number")
    .required("Invalid otp"),
});

export const PasswordValidation = Yup.object().shape({
  newPassword: Yup.string().required("New Password is missing"),
  confirmPassword: Yup.string()
    .oneOf([Yup.ref("newPassword")], "Password not match")
    .required("Confrim Password is missing"),
});

export default EmailValidation; // keep default export if something imports it directly